import { Colors } from '../themes/colors';

interface ILinkProps {
  text: string;
  href: string;
}

export const Link = ({ text, href }: ILinkProps) => (
  <a
    target="_blank"
    rel="noopener noreferrer"
    href={href}
    className="title_font"
    style={{
      color: Colors.secondary_500,
      textDecoration: 'none',
      fontSize: 16,
    }}
  >
    {text}
  </a>
);
